import type { HeadingProps } from "@op/puck-types";
import { cls } from "@op/utils";

function getHeadingClass(level: "section" | "subsection") {
  switch (level) {
    case "section":
      return "text-heading-section font-heading-section";
    case "subsection":
      return "text-heading-subsection font-heading-subsection";
    default:
      throw new Error(`Invalid heading level: ${level}`);
  }
}

function getComponent(level: "section" | "subsection") {
  switch (level) {
    case "section":
      return "h2";
    case "subsection":
      return "h3";
    default:
      throw new Error(`Invalid heading level: ${level}`);
  }
}

function getSpacing(level: "section" | "subsection") {
  switch (level) {
    case "section":
      return "mt-7";
    case "subsection":
      return "mt-4";
    default:
      throw new Error(`Invalid heading level: ${level}`);
  }
}

const Heading = (
  props: HeadingProps & {
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "div";
  }
) => {
  const { children, level = "section", as, className, slug, ...rest } = props;
  const Component = as ?? getComponent(level);

  return (
    <Component
      {...rest}
      className={cls(getHeadingClass(level), getSpacing(level), className)}
      id={slug}
    >
      {children}
    </Component>
  );
};

export default Heading;
